import axios from 'axios';

/**
 * @author Alejandro
 * @param {Object} params
 * @param {string} params.username
 * @param {string} params.password
 * @param {number=} params.season
 */
export function doLogin(params) {
  // return axios.post('https://87y7n81ebc.execute-api.us-west-2.amazonaws.com/prod/', { ...params });
  return axios.post(process.env.VUE_APP_LOGIN_API_URL, { ...params });
}
export function doLoginUnifi(params) {
  // return axios.post('https://87y7n81ebc.execute-api.us-west-2.amazonaws.com/prod/', { ...params });
  return axios.post(process.env.VUE_APP_LOGINUNIFI_API_URL, { ...params });
}

export function doTournaments() {
  // GS20
  // https://kefloixzy1.execute-api.us-west-2.amazonaws.com/prod/tournaments
  // B2C
  // https://17zyhpyc7c.execute-api.us-west-2.amazonaws.com/prod/tournaments
  // prod
  // https://kefloixzy1.execute-api.us-west-2.amazonaws.com/prod/tournaments
  // return axios.get('https://ura1k1h58a.execute-api.us-east-2.amazonaws.com/dev/tournaments');
  return axios.get('https://kefloixzy1.execute-api.us-west-2.amazonaws.com/prod/tournaments');
}
/**
 * @author Ricardo Manzano
 * @param {string} params.user
 * @param {string} params.password
 */
export function doLoginGS(params) {
  return axios.post(process.env.VUE_APP_LOGIN_API_URL_GS, { ...params });
}
